import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Fade } from "./Reveal";

const Spotlight = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      data-testid="spotlight"
      className="relative flex h-[70vh] min-h-[480px] items-center justify-center overflow-hidden border-y border-white/5"
    >
      <motion.img
        style={{ y }}
        src="https://images.unsplash.com/photo-1523039031846-6b3f39302cb8?crop=entropy&cs=srgb&fm=jpg&q=85"
        alt="Copper and steel pots hanging in a dark kitchen"
        loading="lazy"
        className="absolute -top-[10%] left-0 h-[120%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/65" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.1),transparent_60%)]" />

      <Fade className="relative z-10 px-5 text-center" y={40}>
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-brass">
          The Craft
        </span>
        <p className="mx-auto mt-5 max-w-3xl font-display text-3xl italic leading-snug tracking-tight text-stone-100 sm:text-4xl md:text-5xl">
          "The right vessel changes the dish."
        </p>
        <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-stone-400 sm:text-base">
          From the morning dosa tawa to the festival pooja plate — pick the
          metal that suits the job.
        </p>
      </Fade>
    </section>
  );
};

export default Spotlight;
